import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit, Input } from '@angular/core';
import { ClientCheckinEventType } from '@fitness-force/enum';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'fitness-force-check-in-event',
  templateUrl: './check-in-event.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, TranslateModule]
})
export class CheckInEventComponent implements OnInit {
  @Input() columnData = new BehaviorSubject(null)
  @Input() additionData = new BehaviorSubject(null)
  constructor( private translate: TranslateService) { }

  ngOnInit(): void {
  }

  setCheckInEvent(event:any) {
      return ClientCheckinEventType[event as keyof typeof ClientCheckinEventType].toString();
  }

}